import { Button, InputField } from "../../../components/forms";
import { GoDotFill, GoPlus } from "react-icons/go";
import { ListPicker } from "../../../components/generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { Fragment, ReactNode, useEffect, useState } from "react";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import usePositionHook from "../../../hooks/usePositionHook";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { Menu, Transition } from "@headlessui/react";
import { BsCalendar, BsGrid, BsPersonFillDash } from "react-icons/bs";
import { FaCalendar } from "react-icons/fa";
import { IoMdMore, IoMdEye } from "react-icons/io";
import { MdOutlineCancel, MdOutlineInfo } from "react-icons/md";
import { LuUser } from "react-icons/lu";
import { useForm } from "react-hook-form";
import { TbDashboard } from "react-icons/tb";
import AddAppraisalModal from "../../../components/Modules/Employees/AddAppraisalModal";
import useAppraisalHook from "../../../hooks/useAppraisalHook";
import AppraisalList from "./Leave/AppraisalList";
import useLeaveHook from "../../../hooks/useLeaveHook";

const Appraisal = () => {
  const departmentPicked = usePickerhook();
  const statusPicked = usePickerhook();
  const positionPicked = usePickerhook();
  const { selectedOrgEmployees } = useEmployeeHook();
  const [renderedlist, setrenderedlist] = useState(selectedOrgEmployees);
  const { selectedOrgDepts } = useDepartmentHook();
  const { allorgPositions } = usePositionHook();
  const {
    orgappraisals,

    getAllOrgAppraisals,
    allorgappraisal,
  } = useAppraisalHook();
  const tabs = [
    { icon: <BsGrid className=" inline mr-1" />, title: "Grid" },
    { icon: <BsCalendar className=" inline  mr-1 " />, title: "Calender" },
    { icon: <TbDashboard className=" inline  mr-1" />, title: "Dashboard" },
  ];

  const tabViews = [
    <AppraisalList
      refresh={getAllOrgAppraisals}
      appraisals={allorgappraisal}
      isAdminview={true}
      setshowaddleavemodal={() => {}}
    />,
    <></>,
    <></>,
  ];

  const [selectedTabview, setselectedTabview] = useState<JSX.Element>(
    tabViews[0]
  );
  const ActionItem2 = ({ title, icon, key_ }: any) => (
    <div
      onClick={() => {
        setselectedTabview(tabViews[key_]);
        setselectedTab(title);
      }}
      className={`m-1 rounded-[8px] p-2  font-semibold ${
        selectedTab == title
          ? "bg-textbg text-white"
          : " bg-faintBlue text-blueGray "
      }`}
    >
      <p className="  cursor-pointer text-xs flex justify-center items-center ">
        {icon}
        {title}
      </p>
    </div>
  );

  const [selectedTab, setselectedTab] = useState(tabs[0].title);
  const { authuser } = useStateGetter();
  const [showadd, setshowadd] = useState(false);
  const { setselectedEmpl, setSidebarRenderView, setShowModal } =
    useStateSetter();
  const [entered, setentered] = useState("");
  const [target, setTarget] = useState("");
  return (
    <div className="w-full pr-20  flex  ">
      {showadd && (
        <AddAppraisalModal
          target={target}
          refresh={getAllOrgAppraisals}
          show={setshowadd}
        />
      )}
      <div
        className={` p-6 bg-white   h-screen pb-40 w-full  rounded-[20px] overflow-y-scroll `}
      >
        <div className="  w-full  flex gap-4 items-center justify-between  ">
          <div>
            <p className="text-textbg font-medium  mb-2   bg-white">
              Appraisal ({orgappraisals.length})
            </p>
            <div className="border border-gray-300 p-1 flex rounded-md  ">
              {tabs.map((it, key) => (
                <ActionItem2 key_={key} {...it} />
              ))}
            </div>
          </div>

          <Menu as="div" className={`relative my-2 `}>
            <Menu.Button className="   w-full  ">
              <Button
                width={200}
                disabled={false}
                text={
                  <>
                    <GoPlus size={15} className=" mx-1 inline" /> Add Appraisal
                  </>
                }
                onBtnClick={() => {}}
              />
            </Menu.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items
                onClick={() => {
                  setshowadd(true);
                }}
                className="origin-top-left z-10 absolute left-0 mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[250px] min-w-[180px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
              >
                <Menu.Item>
                  <p
                    onClick={() => {
                      setTarget("empl");
                    }}
                    className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
                  >
                    Employee
                  </p>
                </Menu.Item>
                <Menu.Item>
                  <p
                    onClick={() => {
                      setTarget("org");
                    }}
                    className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
                  >
                    Organization
                  </p>
                </Menu.Item>
                <Menu.Item>
                  <p
                    onClick={() => {
                      setTarget("dept");
                    }}
                    className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
                  >
                    Department
                  </p>
                </Menu.Item>

                <Menu.Item>
                  <p
                    onClick={async () => {
                      setTarget("pos");
                    }}
                    className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
                  >
                    Position
                  </p>
                </Menu.Item>
                <Menu.Item>
                  <p
                    onClick={async () => {
                      setTarget("360");
                    }}
                    className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
                  >
                    360 Feedback
                  </p>
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
        <div className="w-full flex justify-between items-center">
          <div className="flex  gap-4">
            <ListPicker
              hook={statusPicked}
              notitle
              title="All status"
              list={[
                { code: "pending", name: "Pending" },
                { code: "approved", name: "Approved" },
                { code: "cancelled", name: "Cancelled" },
                { code: "rejected", name: "Rejected" },
              ]}
            />

            <ListPicker
              hook={departmentPicked}
              notitle
              title="Department"
              list={
                selectedOrgDepts
                  ? selectedOrgDepts?.map((i) => {
                      return { name: i.deptName, code: i.id };
                    })
                  : []
              }
            />
            <ListPicker
              hook={positionPicked}
              notitle
              title="Position"
              list={
                allorgPositions
                  ? allorgPositions?.map((i: any) => {
                      return { name: i.positionTitle, code: i.id };
                    })
                  : []
              }
            />
          </div>
        </div>
        <hr />
        <AppraisalList
          refresh={getAllOrgAppraisals}
          appraisals={allorgappraisal}
          isAdminview={true}
          setshowaddleavemodal={() => {}}
        /> 
      </div>
    </div>
  );
};
export { Appraisal };

const todatestring = (datestring: string) => {
  var date = new Date(datestring);

  return date.toDateString();
};
